export default __webpack_public_path__ + "static/media/right-drawn-arrow.7bc1b07e.svg";